var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.successful)?_c('q-banner',{staticClass:"text-white bg-green",attrs:{"inline-actions":""},scopedSlots:_vm._u([(_vm.dismissible)?{key:"action",fn:function(){return [_c('q-btn',{attrs:{"flat":"","color":"white","label":"X"},on:{"click":_vm.dismiss}})]},proxy:true}:null],null,true)},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    ")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2d1d384","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AlertSuccess.vue
// module id = null
// module chunks = 